import getTranslation from '@/locale/getTranslation'
export default [
  {
    path: '/',
    redirect: 'download'
  },
  {
    path: '/download',
    name: 'download',
    component: resolve => require(['@/views/download/index'], resolve),
    meta: {
      title: getTranslation('下载'),
      keepAlive: true
    }
  },
  {
    path: '/download-conference',
    name: 'download-conference',
    component: resolve => require(['@/views/download/conference'], resolve),
    meta: {
      title: getTranslation('下载'),
      keepAlive: true
    }
  }
]
